<template>

  <tr>
    <td
      v-for="(value, idx) in values"
      :key="idx">

      <template v-if="value">
        {{ value.value.parsed }}
        <span v-show="!value.exists" class="icon has-text-warning">
          <i class="fas fa-exclamation-triangle"></i>
        </span>
      </template>
    </td>
  </tr>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: [
    'dataset'
  ],
  computed: {
    ...mapGetters({
      table: 'tables/table',
      columns: 'columns/columns',
      creatables: 'datasets/creatables'
    }),
    columnValues () {
      return (this.dataset.column_values) ? this.dataset.column_values : this.dataset.columnValues
    },
    values () {
      return this.columns.map(column => {
        return this.columnValues.find(x => x.column_id === column.column.id)
      })
    }
  }
}
</script>

<style scoped>
  .modal-content {
    width: 95%;
  }
</style>
